:host {
  display: flex;
}
div {
  position: relative;
}

klevu-textfield {
  width: 100%;
}

klevu-button {
  margin-left: var(--klevu-spacing-04);
}
